export default {
  title: 'Página inicial',
  greetingText: 'Bem-vindo, {user}',
  description: 'Esta é a página inicial do Criador de Sites'
}
